import {
  IconDashboard,
  IconUsers,
  IconFolder,
  IconClock,
  IconBuilding,
  IconCreditCard,
  IconSettings,
  IconShield,
} from '@tabler/icons-react'

import { useTranslation } from 'react-i18next'
import { NavMain } from '@/components/nav-main'
import { NavSecondary } from '@/components/nav-secondary'
import { NavUser } from '@/components/nav-user'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { useAuthStore } from '@/lib/auth'
import { usePermissions } from '@/lib/permissions'
import { Link } from 'react-router-dom'

const allNavMain = [
  { titleKey: 'nav.dashboard',  url: '/dashboard',      icon: IconDashboard, permission: null },
  { titleKey: 'nav.clients',    url: '/clients',         icon: IconUsers,     permission: { resource: 'client', action: 'read' } },
  { titleKey: 'nav.cases',      url: '/cases',           icon: IconFolder,    permission: { resource: 'aml_case', action: 'read' } },
  { titleKey: 'nav.deadlines',  url: '/deadlines',       icon: IconClock,     permission: { resource: 'deadline', action: 'read' } },
  { titleKey: 'nav.studio',     url: '/studio/profile',  activeUrl: '/studio', icon: IconBuilding,  permission: { resource: 'studio_assessment', action: 'read' } },
]

const allNavSecondary = [
  { titleKey: 'nav.billing',    url: '/billing',   icon: IconCreditCard, permission: { resource: 'wallet', action: 'update' } },
  { titleKey: 'nav.settings',   url: '/settings',  icon: IconSettings,   permission: null },
]

export function AegisSidebar({
  overdueCount,
  upcomingCount,
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  overdueCount: number
  upcomingCount: number
}) {
  const { t } = useTranslation('common')
  const authUser = useAuthStore((s) => s.user)
  const { can } = usePermissions()

  const user = {
    name: authUser ? ([authUser.firstName, authUser.lastName].filter(Boolean).join(' ') || authUser.email) : '',
    studioName: '',
    email: authUser?.email ?? '',
    avatar: '',
  }

  const navMain = allNavMain
    .filter((item) => !item.permission || can(item.permission.resource, item.permission.action))
    .map((item) => ({ ...item, title: t(item.titleKey) }))
  const navSecondary = allNavSecondary
    .filter((item) => !item.permission || can(item.permission.resource, item.permission.action))
    .map((item) => ({ ...item, title: t(item.titleKey) }))
  const deadlineCounts = { overdue: overdueCount, upcoming7d: upcomingCount }

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <Link to="/dashboard">
                <IconShield className="size-5!" />
                <span className="text-base font-semibold">Aegis</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} deadlineCounts={deadlineCounts} />
        {navSecondary.length > 0 && (
          <NavSecondary items={navSecondary} className="mt-auto" />
        )}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
